import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IconButton } from "@totalsoft/rocket-ui";
import { ThinCheckbox } from "components/common/TableStyles.js";
import FlexBox from "components/common/FlexBox";

const HierarchyListItem = ({ data, onEdit, onDelete, canWrite }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover key={data.headerId}>
      <TableCell>{data.hierarchyName}</TableCell>
      <TableCell>{data.hierarchyCode}</TableCell>
      <TableCell align="center">
        <ThinCheckbox disabled={true} size="small" checked={Boolean(data.isActive)} />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent="end">
          <IconButton
            type={canWrite ? "edit" : "view"}
            color="primary"
            size="small"
            variant="text"
            tooltip={canWrite ? t("Edit") : t("View")}
            onClick={() => onEdit(data.partnerHierarchyId)}
          />
          {canWrite ? (
            <IconButton
              disabled={data.isActive}
              type="delete"
              color="primary"
              size="small"
              variant="text"
              tooltip={t("Delete")}
              onClick={() => onDelete(data.partnerHierarchyId)}
            />
          ) : null}
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

HierarchyListItem.propTypes = {
  data: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  canWrite: PropTypes.bool
};

export default HierarchyListItem;
